import { ProtectedRoute } from '../components/ProtectedRoute';
import ProjectLanding from './ProjectLanding';

export default function ProtectedProjectLanding() {
  return (
    <ProtectedRoute>
      <ProjectLanding />
    </ProtectedRoute>
  );
}
